// ============================================================
// OAMATECH ERP PRO - Componente de ruta protegida
// ============================================================
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function RutaProtegida({ children, roles }) {
  const { usuario, cargando } = useAuth();
  const location = useLocation();

  if (cargando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3 text-gray-400">
          <Loader2 size={32} className="animate-spin text-blue-600" />
          <p className="text-sm">Cargando sistema...</p>
        </div>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && usuario.rol !== 'admin') {
    // Permisos personalizados por empleado: si existen, mandan sobre el rol
    const claveModulo = location.pathname.split('/')[1];
    const tienePermisoCustom = Array.isArray(usuario.permisos)
      ? usuario.permisos.includes(claveModulo)
      : roles.includes(usuario.rol);
    if (!tienePermisoCustom) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <p className="text-4xl font-bold text-gray-300 mb-2">403</p>
            <p className="text-gray-500">No tienes permisos para acceder a esta sección</p>
          </div>
        </div>
      );
    }
  }

  return children;
}
